import {getStowAssociateMetrics, getStowFloorMetrics, getStowPackageMetrics} from "../resources/StowResource";
import {publishCount, publishTime} from "../MetricUtility";
import {ERROR_METRIC_SUFFFIX, FEATURES, TOTAL, TRUE} from "../constants";
import {AssociateMetric, StowPackageMetric, Resource, FloorMetric} from "../enums";
import {hasAmxlViewFlagEnabled} from "../Utility";

export const LOAD_FLOOR_LOCATION_METRICS_CALL_BEGIN = "LOAD_FLOOR_LOCATION_METRICS_CALL_BEGIN";
export const LOAD_STOW_PACKAGE_METRICS = "LOAD_STOW_PACKAGE_METRICS";
export const LOAD_TOTAL_STOW_PACKAGE_METRICS = "LOAD_TOTAL_STOW_PACKAGE_METRICS";
export const LOAD_STOW_FLOOR_METRICS = "LOAD_STOW_FLOOR_METRICS";
export const LOAD_STOW_ASSOCIATE_METRICS = "LOAD_STOW_ASSOCIATE_METRICS";
export const LOAD_FLOOR_LOCATION_METRICS_CALL_FAILURE = "LOAD_FLOOR_LOCATION_METRICS_CALL_FAILURE";

const metricProcessName = "SCC_STOW_FLOOR_LOCATION";

const loadMetricsForFloorLocationCallBegin = () => ({
    type: LOAD_FLOOR_LOCATION_METRICS_CALL_BEGIN
});

const loadStowPackageMetricsForFloorLocation = (stowPackageMetricsMap) => ({
    type: LOAD_STOW_PACKAGE_METRICS,
    stowPackageMetricsMap
});

const loadStowPackageTotalMetricsForFloorLocation = (totalStowPackageMetrics) => ({
    type: LOAD_TOTAL_STOW_PACKAGE_METRICS,
    totalStowPackageMetrics
});

const loadStowFloorMetrics = (stowFloorMetricsMap) => ({
    type: LOAD_STOW_FLOOR_METRICS,
    stowFloorMetricsMap
});

const loadStowAssociateMetricsForFloorLocation = (stowAssociateMetricsMap) => ({
    type: LOAD_STOW_ASSOCIATE_METRICS,
    stowAssociateMetricsMap
});

const loadMetricsForFloorLocationCallFailure = () => ({
    type: LOAD_FLOOR_LOCATION_METRICS_CALL_FAILURE
});

export const getStowPackageMetricsForFloorLocation = (nodeId, featureStatus) => {

    const metricName = "getStowPackageMetrics";

    const request = {
        filters: {
            NODE: [nodeId]
        },
        metrics: [
            StowPackageMetric.CURRENT_INDUCTED_COUNT,
            StowPackageMetric.CURRENT_STOWED_COUNT
        ]
    };
    //To be made SIDELINE_V2 by default once stable
    if (featureStatus && featureStatus[FEATURES.SIDELINE_STOW_V2]) {
        request.groupBy = Resource.FLOOR
        request.filters.SIDELINE_V2 = [TRUE];
    } else {
        request.groupBy = Resource.FLOOR_AND_SIDELINE_UNTIL_TIME
        request.filters.SIDELINE = [TRUE];
    }

    //Stow metrics
    request.metrics.push(StowPackageMetric.CURRENT_SCAN_COMPLIANCE)
    request.metrics.push(StowPackageMetric.STOW_RATE)
    if (hasAmxlViewFlagEnabled(nodeId, featureStatus)) {
        request.metrics.push(StowPackageMetric.RESCHEDULED_COUNT)
    }
    request.isAggregationRequired = true;

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForFloorLocationCallBegin());
            const startTime = Date.now();
            const stowPackageMetricsMap = await getStowPackageMetrics(request);
            if (stowPackageMetricsMap) {
                dispatch(loadStowPackageTotalMetricsForFloorLocation(stowPackageMetricsMap[TOTAL]));
                removeUnwantedMetrics(stowPackageMetricsMap);
                dispatch(loadStowPackageMetricsForFloorLocation(stowPackageMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForFloorLocationCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForFloorLocationCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

/**
 * TODO: Unused for now, associate metrics will be added later.
 */
export const getStowAssociateMetricsForFloorLocation = (nodeId) => {

    const metricName = "getStowAssociateMetrics";

    const request = {
        groupBy: Resource.FLOOR_AND_SIDELINE_UNTIL_TIME,
        filters: {
            NODE: [nodeId],
            SIDELINE: [TRUE]
        },
        metrics: [
            AssociateMetric.ACTIVE_ASSOCIATE_COUNT,
            AssociateMetric.INACTIVE_ASSOCIATE_COUNT
        ]
    };

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForFloorLocationCallBegin());
            const startTime = Date.now();
            const stowAssociateMetricsMap = await getStowAssociateMetrics(request);
            if (stowAssociateMetricsMap) {
                removeUnwantedMetrics(stowAssociateMetricsMap);
                dispatch(loadStowAssociateMetricsForFloorLocation(stowAssociateMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForFloorLocationCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForFloorLocationCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowFloorMetricsForFloorLocation = (nodeId, featureStatus) => {

    const metricName = "getStowFloorMetrics";

    const request = {
        filters: {
            NODE: [nodeId]
        },
        metrics: [
            FloorMetric.ATTACHED_CART_COUNT
        ]
    };

    if (featureStatus && featureStatus[FEATURES.SIDELINE_STOW_V2]) {
        request.groupBy = Resource.FLOOR
        request.filters.SIDELINE_V2 = [TRUE];
    } else {
        request.groupBy = Resource.FLOOR_AND_SIDELINE_UNTIL_TIME
        request.filters.SIDELINE = [TRUE];
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForFloorLocationCallBegin());
            const startTime = Date.now();
            const stowFloorMetricsGroupMap = await getStowFloorMetrics(request);
            if (stowFloorMetricsGroupMap) {
                removeUnwantedMetrics(stowFloorMetricsGroupMap);
                dispatch(loadStowFloorMetrics(stowFloorMetricsGroupMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForFloorLocationCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForFloorLocationCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

function removeUnwantedMetrics(metricsMap) {
    // aggregation not required
    delete metricsMap[TOTAL];
}


// WEBPACK FOOTER //
// ./src/actions/FloorLocationActions.js